const { useMediaQuery } = require("@mui/material");

export default function useDeviceType() {
  const isMobile = useMediaQuery("(max-width:750px)");
  const isTablet = useMediaQuery("(max-width:900px)")
  const isDesktop = useMediaQuery("(min-width:750px)")

  return { isMobile, isTablet, isDesktop };
}
